import {
    Box,
} from '@mui/material';
import { WidgetOption } from './WidgetSelector';
import { ChipsInput } from '../ChipsInput';
import { NumericInput } from '../NumericInputField';

type PositionsDist = Models.SetsPlayground.ExplicitPositionsSetDistribution;

interface Props {
    value: PositionsDist;
    onChange: (next: PositionsDist) => void;
    disabled?: boolean;
}

const PositionsDistributionWidgetComponent = ({ value, onChange, disabled }: Props): JSX.Element => {
    const handlePatternSize = (newValue: number | undefined): void => {
        onChange({ ...value, patternSize: newValue });
    };

    const handleOffset = (newValue: number | undefined): void => {
        onChange({ ...value, offset: newValue });
    };

    const handleLimit = (newValue: number | undefined): void => {
        onChange({ ...value, limit: newValue });
    };

    return (
        <Box display="flex" flexDirection="column" gap={2}>
            <Box display="flex" flexDirection="column" gap={2}>
                <ChipsInput
                    disabled={disabled}
                    label="Position"
                    values={value.positions.map(String)}
                    onChange={(newPositions): void => onChange({ ...value, positions: newPositions.map(Number) })}
                />
            </Box>
            <Box display="grid" gap={2} gridTemplateColumns={{ xs: '1fr', sm: 'repeat(3, 1fr)' }}>
                <NumericInput
                    disabled={disabled}
                    label="Pattern Size"
                    min={1}
                    value={value?.patternSize}
                    onChange={handlePatternSize}
                />
                <NumericInput
                    disabled={disabled}
                    label="Offset"
                    min={0}
                    placeholder="Value is zero indexed"
                    value={value?.offset}
                    onChange={handleOffset}
                />
                <NumericInput
                    disabled={disabled}
                    label="Limit"
                    min={1}
                    value={value?.limit}
                    onChange={handleLimit}
                />
            </Box>
        </Box>
    );
};

export const PositionsDistributionWidget: WidgetOption<PositionsDist> = {
    label: 'Explicit Positions',
    value: 'positions',
    helperText: 'Specify exact positions where items from this set should appear in the gallery.',
    component: PositionsDistributionWidgetComponent,
    getDefaultValue: () => ({
        type: 'positions',
        positions: [],
    }),
};
